import React from 'react';
import Marketplace from '../pageComponents/Marketplace';

const MarketplacePage = () => <Marketplace />;

export default MarketplacePage;
